/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable import/no-unresolved */
import React, { useMemo } from 'react'
import { Skeletons } from '@usap/widgets'
import { useResponsiveWrapperContext } from '@usap/uicomponents'
import { useFeatureFlags } from '@usap/core'
import ModuleLoader from './MFE/ModuleLoader'
import mfeConfig from '../../config/mfe-config'
import FallbackHeader from './MFE/FallbackHeader'
import { Header } from './HeaderWmo.css'

const { MfeHeaderSkeleton } = Skeletons

const staticPageRegEx = new RegExp('^st_')

export const noBannerYMMPages = [
  'home',
  'account_login',
  'cart',
  'save_quote',
  'checkout',
  'confirmation',
  'review',
  'account_settings',
  'account_order_history',
  'account_order_details',
  'account_addresses',
  'account_add_address',
  'account_edit_address',
  'account_payment_list',
  'account_add_payment',
  'account_garage',
  'account_rma',
  'get_quote',
  'account_reset',
  'account_track_package',
]

const HeaderWmo = ({ pageType }) => {
  const { isDesktop } = useResponsiveWrapperContext()
  const shouldShowBannerYMM = !noBannerYMMPages.includes(pageType) && __BROWSER__ && !staticPageRegEx.test(__COMBINED_DATA__?.pageType)
  const decisions = useFeatureFlags()

  const mfeComponentParameters = useMemo(() => ({
    navApiUrl: mfeConfig?.navCategoriesApi,
    vehicleApiUrl: mfeConfig?.vehicleApiUrl,
    suggestionsApiUrl: mfeConfig?.suggestionsApiUrl,
    showBannerYMM: shouldShowBannerYMM,
    pageType,
    decisions,
  }), [shouldShowBannerYMM, pageType, decisions])

  return (
    <Header data-testid="mfe-header-wrapper">
      {__BROWSER__ && (
        <ModuleLoader
          url={mfeConfig.headerComponentAppUrl}
          scope={mfeConfig.headerComponentAppName}
          module={mfeConfig.headerComponentAppModule}
          mfeComponentParameters={mfeComponentParameters}
          fallbackTemplate={<FallbackHeader />}
          fallbackSuspense={(
            <MfeHeaderSkeleton
              isDesktop={isDesktop}
              shouldShowBannerYMM={shouldShowBannerYMM}
            />
          )}
        />
      )}
    </Header>
  )
}

export default React.memo(HeaderWmo)
